export enum LatestVersionTopology {
  TABLE = "LatestVersion",
  ENTITY = "entity",
  ENTITY_ID = "entityId",
  VERSION = "version",
  VERSION_ID = "versionId",
}
